
import BankList from './bank-list/index.vue';
import BankDetail from './bank-detail/index.vue';
import AddBank from './add-bank/index.vue';

export default [
  {
    path: 'list',
    name: 'bankList',
    component: BankList,
    meta: {
      title: '银行账户列表',
      breadCrumbShowIndexArr: [0]
    }
  },
  {
    path: 'detail',
    name: 'bankDetail',
    component: BankDetail,
    meta: {
      title: '银行账户详情',
      breadCrumbShowIndexArr: [0, 1, 2]
    }
  },
  {
    path: 'add',
    name: 'addBank',
    component: AddBank,
    meta: {
      title: '添加银行账户',
      breadCrumbShowIndexArr: [0, 1, 2]
    }
  }
];
